module.exports = __webpack_public_path__ + "img/zk-icon-client-list.dfa219fe.svg";